module.exports = __webpack_public_path__ + "static/media/most-active-month-image.7cba279c.webp";